import { Input } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { setGlobalFilter } from "../../app/store/reducers/appSlice";
import { GlobalSearchContainer } from "./styles";

export default function GlobalSearch() {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const filter = useAppSelector(store => store.AppSlice.filter)

  const [searchValue, setSearchValue] = useState("")

  const submitSearch = () => {
    dispatch(setGlobalFilter(searchValue))
  }

  useEffect(() => {
    setSearchValue(filter.seo)
  }, [filter.seo])
  
  return (
    <GlobalSearchContainer>
      <Input
        allowClear={true}
        placeholder={t("GlobalSearchPlaceholder") as string}
        value={searchValue}
        onChange={(evt) => setSearchValue(evt.target.value)}
      />
      <button
        className="page-head__btn btn btn--primary btn--fill"
        children={t("Find")}
        onClick={submitSearch}
      />
    </GlobalSearchContainer>
  )
}
